import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const TermsPage = () => {
  const [content, setContent] = useState('');
  const [updatedAt, setUpdatedAt] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/legal/terms`);
        setContent(response.data.content);
        setUpdatedAt(response.data.updated_at);
      } catch (error) {
        console.error('Failed to load terms:', error);
        setContent('# Terms and Conditions\n\nFailed to load content. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    fetchTerms();
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F9F7]">
      {/* Header */}
      <header className="bg-white border-b border-stone-100">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#1A4D2E] rounded-lg flex items-center justify-center">
              <TrendingUp className="w-5 h-5 text-white" />
            </div>
            <span className="font-serif text-xl font-semibold text-[#1A4D2E]">FictoInvest</span>
          </Link>
          <Link to="/">
            <Button variant="ghost" className="text-gray-600 hover:text-[#1A4D2E]">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-12">
        {loading ? (
          <div className="animate-pulse space-y-4">
            <div className="h-8 bg-stone-200 rounded w-1/3"></div>
            <div className="h-4 bg-stone-200 rounded w-full"></div>
            <div className="h-4 bg-stone-200 rounded w-5/6"></div>
            <div className="h-4 bg-stone-200 rounded w-4/6"></div>
          </div>
        ) : (
          <article className="prose prose-stone max-w-none prose-headings:font-serif prose-headings:text-[#1F2937] prose-a:text-[#1A4D2E] prose-strong:text-[#1F2937]">
            <ReactMarkdown>{content}</ReactMarkdown>
          </article>
        )}
        
        {updatedAt && (
          <p className="text-sm text-gray-400 mt-8 pt-4 border-t border-stone-200">
            Last updated: {new Date(updatedAt).toLocaleDateString()}
          </p>
        )}
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-stone-100 mt-12 py-6">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm text-gray-500 mb-2">
            Educational simulator only. Not financial advice. No real trading.
          </p>
          <div className="flex items-center justify-center gap-4">
            <Link to="/terms" className="text-sm text-[#1A4D2E] font-medium">
              Terms & Conditions
            </Link>
            <span className="text-gray-300">|</span>
            <Link to="/privacy" className="text-sm text-gray-500 hover:text-[#1A4D2E] transition-colors">
              Privacy Policy
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsPage;
